/* src/app/resetpassword/resetpassword.component.scss */
.margin-auto {
  margin: auto !important;
}
.wc-my-auto {
  margin-bottom: auto !important;
  margin-top: auto !important;
}
.ml--1 {
  margin-left: -1px;
}
.ml--2 {
  margin-left: -2px;
}
.ml--3 {
  margin-left: -3px;
}
.ml--4 {
  margin-left: -4px;
}
.ml--5 {
  margin-left: -5px;
}
.ml--6 {
  margin-left: -6px;
}
.ml--7 {
  margin-left: -7px;
}
.ml--8 {
  margin-left: -8px;
}
.ml--9 {
  margin-left: -9px;
}
.ml--10 {
  margin-left: -10px;
}
.ml--15 {
  margin-left: -15px;
}
.mr--5 {
  margin-right: -5px;
}
.mr--10 {
  margin-right: -10px;
}
.mr--15 {
  margin-right: -15px;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.mt-0 {
  margin-top: 0 !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.ml-0 {
  margin-left: 0 !important;
}
.mr-0 {
  margin-right: 0 !important;
}
.m-1 {
  margin: 5px !important;
}
.my-1 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.mx-1 {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.mt-1 {
  margin-top: 5px !important;
}
.mb-1 {
  margin-bottom: 5px !important;
}
.ml-1 {
  margin-left: 5px !important;
}
.mr-1 {
  margin-right: 5px !important;
}
.mb-1-5 {
  margin-bottom: 7.5px !important;
}
.m-2 {
  margin: 10px !important;
}
.my-2 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.mx-2 {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.mt-2 {
  margin-top: 10px !important;
}
.mb-2 {
  margin-bottom: 10px !important;
}
.ml-2 {
  margin-left: 10px !important;
}
.mr-2 {
  margin-right: 10px !important;
}
.m-3 {
  margin: 15px !important;
}
.my-3 {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
.mx-3 {
  margin-left: 15px !important;
  margin-right: 15px !important;
}
.mt-3 {
  margin-top: 15px !important;
}
.mb-3 {
  margin-bottom: 15px !important;
}
.ml-3 {
  margin-left: 15px !important;
}
.mr-3 {
  margin-right: 15px !important;
}
.m-4 {
  margin: 20px !important;
}
.my-4 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.mx-4 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.mt-4 {
  margin-top: 20px !important;
}
.mb-4 {
  margin-bottom: 20px !important;
}
.ml-4 {
  margin-left: 20px !important;
}
.mr-4 {
  margin-right: 20px !important;
}
.m-5 {
  margin: 25px !important;
}
.my-5 {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.mx-5 {
  margin-left: 25px !important;
  margin-right: 25px !important;
}
.mt-5 {
  margin-top: 25px !important;
}
.mb-5 {
  margin-bottom: 25px !important;
}
.ml-5 {
  margin-left: 25px !important;
}
.mr-5 {
  margin-right: 25px !important;
}
.m-6 {
  margin: 30px !important;
}
.my-6 {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
.mx-6 {
  margin-left: 30px !important;
  margin-right: 30px !important;
}
.mt-6 {
  margin-top: 30px !important;
}
.mb-6 {
  margin-bottom: 30px !important;
}
.ml-6 {
  margin-left: 30px !important;
}
.mr-6 {
  margin-right: 30px !important;
}
.mb-8 {
  margin-bottom: 40px !important;
}
.p-0 {
  padding: 0 !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pt-0 {
  padding-top: 0 !important;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.pr-0 {
  padding-right: 0 !important;
}
.p-1 {
  padding: 5px !important;
}
.py-1 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.px-1 {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.pt-1 {
  padding-top: 5px !important;
}
.pb-1 {
  padding-bottom: 5px !important;
}
.pl-1 {
  padding-left: 5px !important;
}
.pr-1 {
  padding-right: 5px !important;
}
.p-2 {
  padding: 10px !important;
}
.py-2 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.px-2 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.pt-2 {
  padding-top: 10px !important;
}
.pb-2 {
  padding-bottom: 10px !important;
}
.pl-2 {
  padding-left: 10px !important;
}
.pr-2 {
  padding-right: 10px !important;
}
.p-3 {
  padding: 15px !important;
}
.py-3 {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.px-3 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.pt-3 {
  padding-top: 15px !important;
}
.pb-3 {
  padding-bottom: 15px !important;
}
.pl-3 {
  padding-left: 15px !important;
}
.pr-3 {
  padding-right: 15px !important;
}
.p-4 {
  padding: 20px !important;
}
.py-4 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.px-4 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.pt-4 {
  padding-top: 20px !important;
}
.pb-4 {
  padding-bottom: 20px !important;
}
.pl-4 {
  padding-left: 20px !important;
}
.pr-4 {
  padding-right: 20px !important;
}
.p-5 {
  padding: 25px !important;
}
.py-5 {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}
.px-5 {
  padding-left: 25px !important;
  padding-right: 25px !important;
}
.pt-5 {
  padding-top: 25px !important;
}
.pb-5 {
  padding-bottom: 25px !important;
}
.pl-5 {
  padding-left: 25px !important;
}
.pr-5 {
  padding-right: 25px !important;
}
.p-6 {
  padding: 30px !important;
}
.py-6 {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.px-6 {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.pt-6 {
  padding-top: 30px !important;
}
.pb-6 {
  padding-bottom: 30px !important;
}
.pl-6 {
  padding-left: 30px !important;
}
.pr-6 {
  padding-right: 30px !important;
}
.px-7 {
  padding-left: 35px !important;
  padding-right: 35px !important;
}
.py-7 {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}
.pb-7 {
  padding-bottom: 35px !important;
}
.px-8 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
.py-8 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.pb-8 {
  padding-bottom: 40px !important;
}
.pt-8 {
  padding-top: 40px !important;
}
.text-justify {
  text-align: justify !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-lighter {
  font-weight: lighter !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-500 {
  font-weight: 500 !important;
}
.font-weight-600 {
  font-weight: 600 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-bolder {
  font-weight: bolder !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  display: block;
  color: #000;
}
.text-blue {
  color: #2e93a1 !important;
}
.text-green {
  color: #229300;
}
.text-danger {
  color: #DE0000;
}
.text-defualt {
  color: #484b59;
  font-weight: 100;
}
.gray-text {
  color: #777777;
}
.text-light-grey {
  color: #949494 !important;
}
.text-white {
  color: #fff;
}
.text-black {
  color: #484b59 !important;
}
.text-orange {
  color: #FF9B05 !important;
}
.text-pink {
  color: #e85d75;
}
.text-dis {
  color: #CCCCCC;
}
.text-light-blue {
  color: #8fdde4;
}
.text-light-orange {
  color: #ffcd82;
}
.text-light-purple {
  color: #d6bdff;
}
.text-6767 {
  color: #676767;
}
.text-warning {
  color: #FFC400 !important;
}
a {
  color: #4dc7f4;
  outline: none;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  cursor: pointer;
  color: #4dc7f4;
}
.spacer {
  width: 1px;
  height: 1px;
}
.spacer2 {
  width: 1px;
}
.wc-d-block {
  display: block;
}
.wc-d-inline {
  display: inline;
}
.wc-d-inline-block {
  display: inline-block;
}
.wc-label {
  display: block;
  font-size: 14px;
  color: #000;
  padding-bottom: 5px;
}
.wc-form-control {
  border-radius: 2px;
  border: 2px solid #d6dde6;
  font-size: 14px;
  line-height: 1.2;
  padding: 6px 12px;
  height: 36px;
  width: 100%;
}
.wc-form-control:focus {
  border-color: #2e93a1;
  outline: none;
}
.wc-textarea {
  height: 100%;
}
.hr-color {
  border-bottom: 1px solid #676767;
}
.hr-color .wc-hr {
  display: inline;
}
.w-100 {
  width: 100%;
}
.h-15 {
  height: 18px;
}
.f-8 {
  font-size: 8px;
  line-height: 1.3;
}
.f-10 {
  font-size: 10px;
  line-height: 1.3;
}
.f-11 {
  font-size: 11px;
  line-height: 1.3;
}
.f-12 {
  font-size: 12px;
  line-height: 1.3;
}
.f-16 {
  font-size: 16px;
  line-height: 1.3;
}
.f-14 {
  font-size: 14px;
  line-height: 1.3;
}
.f-18 {
  font-size: 18px;
  line-height: 1.3;
}
.f-20 {
  font-size: 20px;
  line-height: 1.3;
}
.f-22 {
  font-size: 22px;
  line-height: 1.3;
}
.f-24 {
  font-size: 24px;
  line-height: 1.3;
}
.f-26 {
  font-size: 26px;
  line-height: 1.3;
}
.f-28 {
  font-size: 28px;
  line-height: 1.3;
}
.f-30 {
  font-size: 30px;
  line-height: 1.3;
}
.f-32 {
  font-size: 32px;
  line-height: 1.3;
}
.sep-tag {
  color: #676767;
  font-weight: 500;
  padding-bottom: 15px;
  background-color: #fff;
}
.category {
  color: #949494;
  font-weight: 500;
}
.wc-select {
  background-color: #fff;
  color: #676767;
}
.wc-select option {
  color: #484b59;
}
.wc-select option:disabled {
  color: #676767;
}
.wc-float-right {
  float: right;
}
.wc-float-left {
  float: left;
}
.wc-sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 1020;
  padding-top: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  transition: all 0.3s;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.wc-upload-btn {
  width: 100px;
  height: 100px;
  border: 1px solid #777777;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.wc-upload-btn i {
  font-size: 16px;
  color: #2e93a1;
  position: relative;
  top: 45px;
  color: #2e93a1;
}
.wc-upload-btn .upload-sign {
  position: relative;
  top: 48px;
}
.wc-upload-btn input {
  position: absolute;
  cursor: pointer;
  font-size: 50px;
  opacity: 0;
  right: 0;
  top: 0;
}
.b {
  border: none;
}
.bl,
.bx {
  border-left: none;
}
.br,
.bx {
  border-right: none;
}
.bt,
.by {
  border-top: none;
}
.bb,
.by {
  border-bottom: none;
}
.wc-border {
  border: 1px solid #d1d1d1;
}
.wc-gray-border {
  border: 1px solid #484b59;
}
.br-0 {
  border-radius: inherit !important;
}
.brr-0 {
  border-top-right-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.brl-0 {
  border-top-left-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
}
.brt-0 {
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
}
.brb-0 {
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: white;
  border: 2px solid #777777;
  box-sizing: border-box;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: -1px;
  bottom: 0px;
  background-color: #777777;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: white;
  border-color: #80d7f8;
}
input:focus + .slider {
  box-shadow: 0 0 1px #80d7f8;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  left: -10px;
  margin-right: -4px;
  background-color: #80d7f8;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.forms-top-header {
  width: calc(100% - 145px);
  position: fixed;
  top: 60px;
  margin: 0;
  padding: 20px 0 20px 0;
  background-color: #fff;
  z-index: 2;
}
.main-form {
  position: relative;
  top: 100px;
}
.wc-btn:hover {
  color: #ffffff;
  background-color: #206C79;
}
.wc-btn:focus {
  outline: none;
}
.wc-btn {
  padding: 7px 21px;
  color: #ffffff;
  font-weight: 100;
  border-radius: 2px;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-xs {
  padding: 3px 20px;
  border-radius: 16px;
  color: #ffffff;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
}
.wc-btn-validate {
  background-color: #4a90e2;
}
.wc-btn-registered {
  background-color: #ffcd82;
}
.wc-primary {
  background-color: #2e93a1;
}
.wc-gray-btn {
  background-color: #999999;
}
.wc-white-btn {
  background-color: #fff;
  color: #484b59;
  border: 2px solid #d6dde6 !important;
}
.wc-primary {
  background-color: #2e93a1;
}
.line-height-1 {
  line-height: 1.6;
}
.line-height {
  line-height: 0px;
}
.hc {
  color: #484b59;
}
.bg-blue {
  background-color: #2E93A1;
}
.bg-blue-light {
  background-color: #b3e7fa;
}
.bg-blue-dark {
  background-color: #4a90e2;
}
.bg-blue-2 {
  background-color: #8fdde4;
}
.bg-orange {
  background-color: #FF9B05;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-orange-light {
  background-color: #ffcd82;
}
.bg-gray {
  background-color: #fafafc !important;
}
.bg-gray-dark-2 {
  background-color: #d6dde6;
}
.bg-gray-dark {
  background-color: #d1d1d1;
}
.bg-gray-light {
  background-color: #fafafc;
}
.bg-red-light {
  background-color: #ead1d2;
}
.bg-red {
  background-color: #DE0000;
}
.bg-white {
  background-color: #ffffff;
}
.bg-green {
  background-color: #229300;
}
.bg-brawn {
  background-color: #cbaea5;
}
.bg-black {
  background-color: #484b59;
}
.nobg {
  background-color: transparent;
}
.btn-bg-black {
  background-color: #334059;
}
.btn-interview {
  padding: 8px 15px;
  letter-spacing: 4;
  color: #586e9a;
  border-radius: 2px;
  border: solid 1px #586e9a;
  transition: all 0.5s;
  background-color: #ffffff;
}
.btn-interview:hover,
.btn-interview:active,
.btn-interview:focus {
  color: #ffffff;
  border: solid 1px #586e9a;
  background-color: #586e9a;
}
.red-border {
  border: 1px solid #DE0000;
}
.blue-border {
  border: 1px solid #2e93a1;
}
.black-border {
  border: solid 1px #2C2C2C;
}
.border-stepper {
  border: solid 1px #334059;
}
.step-gray-border {
  border: solid 1px #d1d1d1;
}
.gt {
  color: #999999;
}
.text-blue-gray {
  color: #8094B1;
}
.light-blue-text {
  color: #012964;
}
.black-text {
  color: #000;
}
.green-text {
  color: #4ac98d;
}
.wccard {
  border-radius: 2px;
  background-color: #fff;
}
.wc-border {
  border: 2px solid #ECF0F4;
}
.wc-bl {
  border-left: 2px solid #ECF0F4;
}
.wc-br {
  border-right: 2px solid #ECF0F4;
}
.wc-bt {
  border-top: 2px solid #ECF0F4;
}
.wc-bb {
  border-bottom: 2px solid #ECF0F4;
}
.bg-warning {
  background-color: #FFC400;
}
.bg-light-green {
  background-color: #d3e9cc;
}
.bg-light-red {
  background-color: rgba(222, 0, 0, 0.2);
}
.paused-color {
  background-color: #FFF3CC;
}
.bg-img {
  background-color: #f5f6f9;
}
.hrcolor {
  border-top: 1px solid #ECF0F4;
}
.z-1 {
  z-index: -1;
}
.z0 {
  z-index: 0;
}
.z1 {
  z-index: 1;
}
.z2 {
  z-index: 2;
}
.z3 {
  z-index: 3;
}
.z4 {
  z-index: 4;
}
.z5 {
  z-index: 5;
}
.wc-box-shadow {
  box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.pointer {
  cursor: pointer;
}
.c-logo {
  width: 50px;
  height: 50px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-mini {
  width: 30px;
  height: 30px;
  background-color: rgba(48, 5, 127, 0.04);
  padding: 5px;
}
.c-logo-mini img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md {
  width: 80px;
  height: 80px;
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 24px;
}
.c-logo-md img {
  width: 100%;
  height: auto;
  vertical-align: center;
  text-align: center;
}
.c-logo-md i {
  font-size: 40px;
}
.showpassword {
  position: absolute;
  top: 10px;
  right: 4%;
}
.listStyleBullet > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.listStyleBullet > ul li {
  padding: 2px 0;
}
.listStyleBullet div > ul {
  list-style: inherit !important;
  margin-left: 15px;
}
.strikethrough {
  text-decoration: line-through;
  color: #999999;
}
.anchor-text {
  color: #4dc7f4 !important;
}
.tl0 {
  top: 0;
  left: 0;
}
.tr0 {
  top: 0;
  right: 0;
}
.ats-cta-btn:hover i {
  color: #206C79;
}
.ats-cta-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-color: #D5E9EC;
  padding: 5px 8px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.ats-cta-btn i {
  color: #2E93A1;
  font-size: 14px;
  font-weight: 600;
}
.wc-progress-profile {
  background-color: rgba(103, 198, 187, 0.2);
  border-radius: 1rem;
}
.wc-progress-profile .wc-progress-bar {
  background-color: rgb(103, 198, 187);
}
.mt-3px {
  margin-top: 3px;
}
.mb-3px {
  margin-bottom: 1px;
}
label {
  font-size: 12px;
}
.no-outline {
  outline: none;
}
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}
.text-484b59 {
  color: #484b59;
}
.yrofexp {
  width: 160px;
  float: left;
}
.yrofexp input[type=number] {
  width: 60px;
  float: left;
  z-index: 2;
  position: relative;
  font-size: 14px;
}
.yrofexp input[type=text] {
  width: 90px;
  float: left;
  z-index: 2;
  margin-left: -2px;
  text-align: center;
}
.yrofexp input[type=text]:focus {
  border: 2px solid #d6dde6;
}
.yrofexp label {
  width: 100px;
  float: left;
  padding: 7.5px 12px;
  border: 2px solid #d6dde6;
  margin-left: -2px;
  border-radius: 0 2px 2px 0;
  color: #000;
  text-align: center;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.form-control-sm::-webkit-inner-spin-button,
.form-control-sm::-webkit-outer-spin-button {
  -webkit-appearance: auto !important;
  appearance: auto !important;
  margin: 0;
}
.upload-container {
  width: 100%;
  float: left;
  height: 80px;
  color: #2e93a1;
  border: 2px solid #fafafc;
  cursor: pointer;
  position: relative;
  transition: 0.4s;
  border-radius: 2px;
}
.upload-container .upload--btn {
  width: 76px;
  height: 100%;
  padding: 22px 30px;
  background-color: #fafafc;
  font-size: 24px;
  position: absolute;
  transition: 0.4s;
  z-index: 2;
}
.upload-container .upload--section {
  width: 100%;
  text-align: left;
  position: absolute;
  left: 0;
  line-height: 76px;
  padding-left: 100px;
  transition: 0.4s;
  z-index: 0;
}
.upload-container input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.upload-container:hover {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
.upload-container:hover .upload--btn {
  background-color: #2e93a1;
  color: #fff;
  transition: 0.4s;
  z-index: 2;
}
.upload-container:hover .upload--section {
  background-color: #fafafc;
  color: #2e93a1;
  transition: 0.4s;
  z-index: 0;
}
.upload-container:focus {
  color: #2e93a1;
  border: 2px solid #2e93a1;
}
#b2bfd0 ::placeholder {
  color: red !important;
}
:-ms-input-placeholder {
  color: red !important;
}
::-ms-input-placeholder {
  color: red !important;
}
.genderBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.genderBtn .genderRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.genderBtn .genderText {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.genderBtn > input[type=radio]:checked + .genderText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  z-index: 2;
}
.wc-checkbox {
  width: 20px !important;
  height: 20px !important;
  position: relative;
  left: 0;
  top: 0;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 20px;
  height: 20px;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
}
.wc-radioBtn {
  position: relative;
  left: 0;
  transition: 0.4s;
  width: 100px;
  height: 40px;
}
.wc-radioBtn .teamRadio {
  width: 100px;
  height: 30px;
  position: absolute;
}
.wc-radioBtn .teamText {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border: 2px solid #d6dde6;
  border-radius: 3px;
  text-align: center;
  color: #000;
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.wc-radioBtn > input[type=radio]:checked + .teamText,
.wc-radioBtn > input[type=checkbox]:checked + .teamText {
  color: #fff;
  background-color: #2e93a1;
  border: 2px solid #2e93a1;
  transition: 0.5s;
  font-weight: bold;
  cursor: pointer;
}
.wc-ghostBtn {
  padding: 7px 21px;
  border: 1px solid #969696;
  background-color: #fff;
  color: #484b59;
  transition: 0.5s;
  outline: none;
  border-radius: 3px;
}
.wc-ghostBtn:hover {
}
.wc-ghostBtn:focus {
  color: #2e93a1;
  background-color: #fff;
}
.wc-ghostdisabled {
  color: #999999;
  border: 2px solid #999999;
  background-color: #fff;
  outline: none;
}
.wc-ghostBtnRed {
  border: 2px solid #DE0000;
  background-color: #fff;
  color: #DE0000;
  transition: 0.5s;
  outline: none;
}
.wc-ghostBtnRed:hover {
  color: #fff;
  background-color: #DE0000;
}
.wc-ghostBtnRed:focus {
  color: #fff;
  background-color: #DE0000;
}
@media only screen and (max-width: 1440px) {
  .wc-checkbox {
    width: 25px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 30px;
    height: 20px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 1170px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media (max-width: 768px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    max-width: 95%;
    margin: 1.75rem auto;
  }
}
@media only screen and (max-width: 768px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (max-width: 576px) {
  .wc-checkbox {
    width: 25px;
    height: 25px;
  }
  .wc-checkbox input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
}
.ats-upload-btn {
  width: 100%;
  border: dashed 0.5px #b0bed2;
  color: #484b59;
  display: flex;
  box-sizing: border-box;
  position: relative;
}
.ats-upload-btn span {
  color: #d1d1d1;
  font-size: 34px;
  line-height: 1;
  z-index: 0;
}
.ats-upload-btn .ats--upload-cv,
.ats-upload-btn .ats--upload-linkedin {
  width: 50%;
  float: left;
  padding: 20px;
  border-right: 1px dashed #b0bed2;
  box-sizing: border-box;
  z-index: 0;
}
.ats-upload-btn .ats--upload-linkedin {
  border-right: none;
}
.ats-upload-btn input {
  position: absolute;
  height: 100%;
  width: 100%;
  outline: none;
  cursor: pointer;
  opacity: 0;
}
.social-check {
  position: relative;
  cursor: pointer;
  margin-right: 10px;
}
.social-check input[type=checkbox] {
  width: 15px;
  height: 15px;
  opacity: 0;
}
.social-check i {
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
  color: #b2bfd0;
  cursor: pointer;
  transition: 0.5s;
}
.social-check input[type=checkbox]:checked + i {
  transition: 0.5s;
  color: #2e93a1;
}
input[type=month]::-webkit-inner-spin-button {
  display: none;
}
input[type=month]::-webkit-calendar-picker-indicator {
  opacity: 0;
  z-index: 2;
}
div.uploadFile {
  position: relative;
}
div.uploadFile input[type=file] {
  width: 100%;
  padding: 6px 12px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 2;
}
div.uploadFile span {
  position: absolute;
  left: 12px;
  top: 7px;
  z-index: 0;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 93%;
  white-space: nowrap;
}
div.uploadFile span i {
  color: #b2bfd0;
  cursor: pointer;
}
.custom-control-label::before {
  background-color: #fff;
  border: #2e93a1 solid 1px;
}
.custom-control-label::after {
  background-color: #2e93a1;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2e93a1;
  background-color: #2e93a1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  -webkit-transform: translateX(0.75rem);
  transform: translateX(0.75rem);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #2e93a1;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(48, 5, 127, 0.4);
}
.wc-can-cta .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
@media (max-width: 576px) {
  .ats-upload-btn {
    width: 100%;
    height: 100%;
    border: dashed 0.5px #b0bed2;
    color: #484b59;
    display: block;
    box-sizing: border-box;
    position: relative;
  }
  .ats-upload-btn span {
    color: #d1d1d1;
    font-size: 50px;
    line-height: 1;
    z-index: 0;
  }
  .ats-upload-btn .ats--upload-cv,
  .ats-upload-btn .ats--upload-linkedin {
    width: 100%;
    float: left;
    padding: 40px;
    border-right: 1px dashed #b0bed2;
    box-sizing: border-box;
    z-index: 0;
    display: block;
    border-bottom: 1px dashed #b0bed2;
  }
  .ats-upload-btn .ats--upload-linkedin {
    border-right: none;
    border-bottom: none;
  }
  .ats-upload-btn input {
    position: absolute;
    height: 100%;
    width: 100%;
    outline: none;
    cursor: pointer;
    opacity: 0;
    display: block;
  }
}
.bg-banner {
  background: url("./media/bg-image-ZQ6KMGTV.png");
  background-position: left top;
  background-size: cover;
  height: 100%;
}
.bg-banner .blueOverlay {
  position: absolute;
  opacity: 0.9;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 333;
  height: 100%;
}
.py-40 {
  padding-top: 45px;
}
.centeredForm {
  margin-top: 80px;
}
.logowidth {
  width: 45px;
  height: auto;
}
.wc-logotext {
  font-size: 30px;
  color: #fff;
}
.text-fafafa {
  color: #fafafa;
}
.iconDiv {
  width: 45px;
  float: left;
}
.textDiv {
  width: calc(100% - 45px);
  float: left;
}
.overlay {
  width: 100%;
  height: 80%;
  background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgb(34, 53, 78));
  position: absolute;
  bottom: 0%;
}
.h100vh {
  height: 100vh;
}
#loginContainer {
  position: fixed;
  top: 0;
  left: 0;
}
@media only screen and (max-width: 600px) {
  .h100vh {
    height: 135vh;
  }
}
.logowidth {
  width: 35px;
  height: auto;
}
.wc-logotext {
  font-size: 22px;
  color: #FF9B05;
  vertical-align: -webkit-baseline-middle;
  line-height: 1;
  font-weight: 600;
}
.nav-pills .nav-link {
  border-radius: 3px;
  background-color: #F5F6F9;
}
.nav-link {
  display: block;
  padding: 0.5rem 2.5rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  font-weight: bold;
  background-color: #2e93a1;
}
.test {
  position: relative;
}
.test input[type=text] {
  background-color: transparent;
  z-index: 1;
}
.test .droparrow-down,
.test .droparrow-up {
  position: absolute;
  top: 9px;
  right: 15px;
  color: #d6dde6;
}
.test .fa-chevron-up {
  display: none;
}
input[type=text]:focus + .droparrow-down .fa-chevron-down {
  display: none;
  color: #2e93a1;
}
input[type=text]:focus + .droparrow-down .fa-chevron-up {
  display: block;
  color: #2e93a1;
}
.progress-c {
  width: 100px;
  height: 100px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
  border: 5px solid #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2e93a1;
  font-weight: bold;
}
.wc-linked-btn-1,
.wc-uplaodrsume-btn-1 {
  width: 45%;
  float: left;
  color: #008bc2;
  border: 2px solid #008bc2;
  border-radius: 2px;
  margin-left: 15px;
  cursor: pointer;
}
.wc-linked-btn-1 .wc-linked-btn-i,
.wc-linked-btn-1 .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1 .wc-linked-btn-i,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  padding: 8px 9px;
  display: inline-flex;
  border-right: 2px solid #008bc2;
  justify-content: center;
}
.wc-linked-btn-1 .wc-linked-btn-t,
.wc-linked-btn-1 .wc-uplaodrsume-btn-t,
.wc-uplaodrsume-btn-1 .wc-linked-btn-t,
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-t {
  padding: 3px 10px;
  display: inline-flex;
  justify-content: center;
  width: calc(100% - 36px);
}
.wc-linked-btn-1:hover,
.wc-uplaodrsume-btn-1:hover {
  color: #ffffff;
  background: #008bc2;
  border: 2px solid transparent;
  transition: 0.5s;
}
.wc-linked-btn-1:hover .wc-linked-btn-i,
.wc-linked-btn-1:hover .wc-uplaodrsume-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-linked-btn-i,
.wc-uplaodrsume-btn-1:hover .wc-uplaodrsume-btn-i {
  border-right: 2px solid #fff;
  padding: 8px 9px;
}
.wc-uplaodrsume-btn-1 {
  position: relative;
  color: #84DA28;
  border: 2px solid #84DA28;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .wc-uplaodrsume-btn-i {
  border-right: 2px solid #84DA28;
}
.wc-uplaodrsume-btn-1 .resumeuplad {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1 .resumeuplad input[type=file] {
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}
.wc-uplaodrsume-btn-1:hover {
  background: #84DA28;
}
button.close {
  outline: none;
}
input.wc-form-control:focus {
  z-index: 2;
}
.test input[type=text]:focus {
  z-index: 2;
}
.content {
  padding: 0px !important;
}
.webtree-outline-success {
  color: #2e93a1;
  border-color: #2e93a1;
  border-radius: 2px;
  padding: 10px 24px;
  letter-spacing: 0.31px;
}
.webtree-outline-success:hover {
  color: #ffffff;
  background-color: #2e93a1;
}
.z2 {
  z-index: 2;
}
.heroTextConatiner {
  position: absolute;
  top: 17%;
}
.heroText {
  font-size: 48px;
  font-weight: bold;
  line-height: 1.17;
  text-align: center;
}
.subheading {
  font-size: 18px;
  line-height: 1.56;
  text-align: center;
}
.wc-btn-lg {
  padding: 9px 26px;
  border-radius: 3px;
  background-color: #2e93a1;
  color: #ffffff;
  font-weight: bold;
}
.wc-btn-lg:hover {
  color: #ffffff;
  background-color: #206c79;
}
.serachforTalent {
  position: absolute;
  top: 70%;
}
.searchSmarttalent {
  margin-top: 55px;
  width: 410px;
  padding-left: 30px;
}
.w-95 {
  width: 95%;
}
.campaigns {
  background-color: #af2c2c;
}
.linkedinColor {
  color: #0e76a8;
}
.twitterColor {
  color: #000000;
}
.facebookColor {
  color: #3b5998;
}
.youtubeColor {
  color: #c4302b;
}
.emailColor {
  color: #206c79;
}
.bgS1 {
  background-color: #f2f8f9;
}
.h100vh {
  max-height: 100%;
  height: 100vh;
  min-height: 100vh;
}
.test::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 50%;
  bottom: 0px;
  background-color: #f2f8f9;
  z-index: -1;
}
.test2::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0%;
  bottom: 0px;
  background-color: #f2f8f9;
  z-index: -1;
}
.tr {
  width: 100%;
  text-align: center;
  top: 30px;
  left: 0%;
}
.tr0 {
  top: 51%;
  left: 0;
}
.webtree-input {
  width: 100%;
  padding: 5px 12px;
  border-radius: 2px;
  border: solid 1px #b3b3b3;
  background-color: #ffffff;
}
.webtree-input:focus {
  outline: none;
}
.bgRequestBtn {
  height: 40px;
}
.pl35 {
  padding-left: 35px;
}
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0rem rgb(46, 147, 161);
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0rem rgb(46, 147, 161);
}
.btn-outline-success.focus,
.btn-outline-success:focus {
  box-shadow: 0 0 0 0rem rgb(46, 147, 161);
}
.btn-outline-success:not(:disabled):not(.disabled):active,
.show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #2e93a1;
  border-color: #2e93a1;
}
.content {
  padding: 15px 15px 15px 15px;
}
#section1 {
  margin-top: -102px;
  width: 100%;
  height: 100%;
  background-image:
    url(/assets/oval-1.png),
    url(/assets/oval-2-test.png),
    url(/assets/oval-3.png);
  background-repeat:
    no-repeat,
    no-repeat,
    no-repeat;
  background-position:
    top -8% left 0%,
    top 175px right 1%,
    top 480px left 0%;
  background-size:
    18%,
    37%,
    27%;
  position: relative;
}
.heroTextConatiner {
  position: absolute;
  top: 18%;
  left: 0;
}
.section1Height {
  height: 1230px;
}
.aisourcing {
  position: absolute;
  left: 10%;
  top: 40px;
}
.serachforTalent {
  position: absolute;
  top: 58%;
  left: 0;
}
#section2 {
  width: 100%;
  height: 100%;
  background-image: url(/assets/oval-4.png);
  background-repeat: no-repeat;
  background-position: top 0% right 0%;
  background-size: 23% 100%;
}
#section3 {
  width: 100%;
  height: 100%;
  background-image: url(/assets/oval-5.png);
  background-repeat: no-repeat;
  background-position: top 0% left 0%;
  background-size: 25%;
  margin-top: 100px;
  padding-bottom: 100px;
  margin-bottom: 100px;
}
#section4 {
  background-color: #f5f9f9;
}
.colmd8 {
  -ms-flex: 0 0 81.666667%;
  flex: 0 0 81.666667%;
  max-width: 81.666667%;
}
.container {
  max-width: 1240px;
}
.colmd8W {
  -ms-flex: 0 0 66.666667%;
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}
.arrow-right {
  position: absolute;
  right: 0px;
  top: 100px;
}
.arrow-left-1 {
  position: absolute;
  left: -26%;
  top: 38%;
}
.arrow-left-11 {
  position: absolute;
  margin-top: 30px;
}
.w380 {
  width: 380px;
}
.w-65 {
  width: 65px;
}
.h-100vh {
  height: 100vh;
}
@media only screen and (max-width: 1680px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top -6% left 0%,
      top 175px right 1%,
      top 480px left 0%;
    background-size:
      20%,
      42% 60%,
      30%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 0% right 0%;
    background-size: contain;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 100px;
    padding-bottom: 100px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -19.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: 30px;
  }
}
@media only screen and (max-width: 1440px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top 0% left 0%,
      top 175px right 1%,
      top 480px left 0%;
    background-size:
      25%,
      45% 50%,
      33%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 0% right 0%;
    background-size: contain;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 70px;
    margin-bottom: 70px;
  }
  .serachforTalent {
    position: absolute;
    top: 54%;
  }
  .aisourcing {
    position: absolute;
    left: 10%;
    top: 40px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 15%;
  }
  .section1Height {
    height: 1100px;
  }
  .colmd8W {
    -ms-flex: 0 0 86.666667%;
    flex: 0 0 86.666667%;
    max-width: 86.666667%;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -9.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: 30px;
  }
}
@media only screen and (max-width: 1368px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top 0% left 0%,
      top 175px right 1%,
      top 480px left 0%;
    background-size:
      25%,
      45% 50%,
      40% 53%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 0% right 0%;
    background-size: contain;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 70px;
    margin-bottom: 70px;
  }
  .serachforTalent {
    position: absolute;
    top: 54%;
  }
  .aisourcing {
    position: absolute;
    left: 10%;
    top: 40px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 17%;
  }
  .section1Height {
    height: 1100px;
  }
  .colmd8W {
    -ms-flex: 0 0 86.666667%;
    flex: 0 0 86.666667%;
    max-width: 86.666667%;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -6.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: 30px;
  }
}
@media only screen and (max-width: 1280px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top 0% left 0%,
      top 140px right 3%,
      top 400px left 0%;
    background-size:
      22%,
      45% 50%,
      35% 53%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 0% right 0%;
    background-size: contain;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 70px;
    margin-bottom: 70px;
  }
  .serachforTalent {
    position: absolute;
    top: 53%;
  }
  .aisourcing {
    position: absolute;
    left: 5%;
    top: 40px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 15%;
  }
  .section1Height {
    height: 1000px;
  }
  .colmd8W {
    -ms-flex: 0 0 86.666667%;
    flex: 0 0 86.666667%;
    max-width: 86.666667%;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -2.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: 30px;
  }
}
@media only screen and (max-width: 1024px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top 0% left 0%,
      top 120px right 5%,
      top 444px left 0%;
    background-size:
      25%,
      58% 52%,
      48% 50%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 0% right 0%;
    background-size: 37% 100%;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: 40% 90%;
    margin-top: 70px;
    padding-bottom: 70px;
    margin-bottom: 20px;
  }
  .serachforTalent {
    position: absolute;
    top: 60%;
  }
  .aisourcing {
    position: absolute;
    left: 10%;
    top: 55px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 16%;
  }
  .section1Height {
    height: 1050px;
  }
  .colmd8 {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .colmd8W {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .container {
    max-width: 960px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -5.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: -20px;
    margin-left: -3px;
  }
  .w-95 {
    width: 100%;
  }
  .mr-75 {
    margin-right: -75px;
  }
  .par-31 {
    position: absolute;
    right: -31px;
  }
  .ml-50 {
    margin-left: -50px;
  }
}
@media only screen and (max-width: 768px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top 0% left 0%,
      top 120px right 5%,
      top 444px left 0%;
    background-size:
      25%,
      58% 52%,
      48% 50%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 0% right 0%;
    background-size: 37% 100%;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: 40% 90%;
    margin-top: 70px;
    padding-bottom: 70px;
    margin-bottom: 20px;
  }
  .serachforTalent {
    position: absolute;
    top: 60%;
  }
  .aisourcing {
    position: absolute;
    left: 10%;
    top: 55px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 16%;
  }
  .section1Height {
    height: 1050px;
  }
  .colmd8 {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .colmd8W {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .container {
    max-width: 960px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -5.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: -20px;
    margin-left: -3px;
  }
  .w-95 {
    width: 100%;
  }
  .mr-75 {
    margin-right: -45px;
  }
  .par-31 {
    position: absolute;
    right: 0px;
  }
  .ml-50 {
    margin-left: -15px;
  }
}
@media only screen and (max-width: 600px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top 0% left 0%,
      top 120px right 5%,
      top 490px left 0%;
    background-size:
      32%,
      64% 35%,
      60% 40%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 133px right 0%;
    background-size: 60%;
    margin-top: 60px;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 70px;
    margin-bottom: 20px;
  }
  #section4 {
    background-color: #f5f9f9;
    position: relative;
    display: block;
    top: 500px;
  }
  #section5 {
    position: relative;
    display: block;
    top: 500px;
  }
  .serachforTalent {
    position: absolute;
    top: 50%;
  }
  .aisourcing {
    position: absolute;
    left: 10%;
    top: 55px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 12%;
  }
  .section1Height {
    height: 1330px;
  }
  .colmd8 {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .colmd8W {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .container {
    max-width: 960px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -5.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: -70px;
    margin-left: -3px;
  }
  .w-95 {
    width: 100%;
  }
  .mr-75 {
    margin-right: -30px;
  }
  .par-31 {
    position: absolute;
    right: 0px;
  }
  .ml-50 {
    margin-left: -15px;
  }
  .mtsm-50px {
    margin-top: 50px;
  }
  .test::before,
  .testmobile::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0%;
    bottom: 0px;
    background-color: #f2f8f9;
    z-index: -1;
  }
  .p-5 {
    padding-bottom: 0 !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .w-65 {
    width: 65px;
  }
}
@media only screen and (max-width: 425px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top -5% left 0%,
      top 120px right 5%,
      top 675px left 0%;
    background-size:
      45%,
      97% 40%,
      90% 40%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 50px right 0%;
    background-size: 80%;
    margin-top: 135px;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  #section4 {
    background-color: #f5f9f9;
    position: relative;
    display: block;
    top: 430px;
  }
  #section5 {
    position: relative;
    display: block;
    top: 430px;
  }
  .serachforTalent {
    position: absolute;
    top: 63%;
  }
  .aisourcing {
    position: absolute;
    left: 17%;
    top: 115px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 12%;
  }
  .section1Height {
    height: 1330px;
  }
  .colmd8 {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .colmd8W {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .container {
    max-width: 960px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -5.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: -70px;
    margin-left: -3px;
  }
  .w-95 {
    width: 100%;
  }
  .mr-75 {
    margin-right: -30px;
  }
  .par-31 {
    position: absolute;
    right: 0px;
  }
  .ml-50 {
    margin-left: -15px;
  }
  .mtsm-50px {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 375px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top -5% left 0%,
      top 120px right 5%,
      top 675px left 0%;
    background-size:
      50%,
      96% 33%,
      90% 40%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 50px right 0%;
    background-size: 80%;
    margin-top: 135px;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  #section4 {
    background-color: #f5f9f9;
    position: relative;
    display: block;
    top: 375px;
  }
  #section5 {
    position: relative;
    display: block;
    top: 375px;
  }
  .serachforTalent {
    position: absolute;
    top: 63%;
  }
  .aisourcing {
    position: absolute;
    left: 17%;
    top: 115px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 12%;
  }
  .section1Height {
    height: 1330px;
  }
  .colmd8 {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .colmd8W {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .container {
    max-width: 960px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -5.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: -70px;
    margin-left: -3px;
  }
  .w-95 {
    width: 100%;
  }
  .mr-75 {
    margin-right: -30px;
  }
  .par-31 {
    position: absolute;
    right: 0px;
  }
  .ml-50 {
    margin-left: -15px;
  }
  .mtsm-50px {
    margin-top: 50px;
  }
  .w380 {
    width: 320px;
  }
  .heroText {
    font-size: 42px;
    font-weight: bold;
    line-height: 1.17;
    text-align: center;
  }
}
@media only screen and (max-width: 360px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top -5% left 0%,
      top 120px right 5%,
      top 675px left 0%;
    background-size:
      50%,
      96% 33%,
      90% 40%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 50px right 0%;
    background-size: 80%;
    margin-top: 135px;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  #section4 {
    background-color: #f5f9f9;
    position: relative;
    display: block;
    top: 375px;
  }
  #section5 {
    position: relative;
    display: block;
    top: 375px;
  }
  .serachforTalent {
    position: absolute;
    top: 63%;
  }
  .aisourcing {
    position: absolute;
    left: 17%;
    top: 115px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 12%;
  }
  .section1Height {
    height: 1330px;
  }
  .colmd8 {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .colmd8W {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .container {
    max-width: 960px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -5.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: -70px;
    margin-left: -3px;
  }
  .w-95 {
    width: 100%;
  }
  .mr-75 {
    margin-right: -30px;
  }
  .par-31 {
    position: absolute;
    right: 0px;
  }
  .ml-50 {
    margin-left: -15px;
  }
  .mtsm-50px {
    margin-top: 50px;
  }
  .w380 {
    width: 320px;
  }
  .heroText {
    font-size: 42px;
    font-weight: bold;
    line-height: 1.17;
    text-align: center;
  }
  .webtree-outline-success {
    color: #2e93a1;
    border-color: #2e93a1;
    border-radius: 2px;
    padding: 10px 15px;
    letter-spacing: 0.31px;
  }
}
@media only screen and (max-width: 320px) {
  #section1 {
    margin-top: -102px;
    width: 100%;
    height: 100%;
    background-image:
      url(/assets/oval-1.png),
      url(/assets/oval-2-test.png),
      url(/assets/oval-3.png);
    background-repeat:
      no-repeat,
      no-repeat,
      no-repeat;
    background-position:
      top -5% left 0%,
      top 120px right 5%,
      top 675px left 0%;
    background-size:
      50%,
      96% 33%,
      90% 40%;
    position: relative;
  }
  #section2 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-4.png);
    background-repeat: no-repeat;
    background-position: top 50px right 0%;
    background-size: 80%;
    margin-top: 135px;
  }
  #section3 {
    width: 100%;
    height: 100%;
    background-image: url(/assets/oval-5.png);
    background-repeat: no-repeat;
    background-position: top 0% left 0%;
    background-size: contain;
    margin-top: 70px;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  #section4 {
    background-color: #f5f9f9;
    position: relative;
    display: block;
    top: 375px;
  }
  #section5 {
    position: relative;
    display: block;
    top: 375px;
  }
  .serachforTalent {
    position: absolute;
    top: 63%;
  }
  .aisourcing {
    position: absolute;
    left: 17%;
    top: 115px;
  }
  .heroTextConatiner {
    position: absolute;
    top: 12%;
  }
  .section1Height {
    height: 1330px;
  }
  .colmd8 {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .colmd8W {
    -ms-flex: 0 0 98.666667%;
    flex: 0 0 98.666667%;
    max-width: 98.666667%;
  }
  .container {
    max-width: 960px;
  }
  .arrow-right {
    position: absolute;
    right: 0px;
    top: 100px;
  }
  .arrow-left-1 {
    position: absolute;
    left: -5.5%;
    top: 38%;
  }
  .arrow-left-11 {
    position: absolute;
    margin-top: -70px;
    margin-left: -3px;
  }
  .w-95 {
    width: 100%;
  }
  .mr-75 {
    margin-right: -30px;
  }
  .par-31 {
    position: absolute;
    right: 0px;
  }
  .ml-50 {
    margin-left: -15px;
  }
  .mtsm-50px {
    margin-top: 50px;
  }
  .w380 {
    width: 300px;
  }
  .heroText {
    font-size: 34px;
    font-weight: bold;
    line-height: 1.17;
    text-align: center;
  }
  .webtree-outline-success {
    color: #2e93a1;
    border-color: #2e93a1;
    border-radius: 2px;
    padding: 10px 10px;
    letter-spacing: 0.31px;
  }
  .navbar-brand {
    display: inline-block;
    padding-top: 0;
    padding-bottom: 0;
    margin-right: 1rem;
    font-size: 0;
    line-height: inherit;
    white-space: nowrap;
    width: 45%;
  }
  .navbar-brand img {
    width: 100%;
  }
  .w-65 {
    width: 65px;
  }
}
.btnreset {
  color: #2E93A1;
  border: 1px solid #2E93A1;
  background-color: white;
}
.text-webbtree-green {
  color: #2e93a1;
}
.text-webbtree-green:hover {
  color: #206c79;
}
.signup-div {
  background: white;
}
.h-100v {
  height: 100vh;
}
.pt-100 {
  padding-top: 100px;
}
.pt-40 {
  padding-top: 40px;
}
.google-div {
  padding: 7px 25px 7px 0px;
  border-radius: 2px;
  background-color: #F44336;
  width: fit-content;
  color: #FFFFFF;
}
.google-icon {
  color: #FFFFFF;
  margin-left: 8px;
}
.linkedin-div {
  padding: 7px 25px 7px 0px;
  border-radius: 2px;
  background-color: #0E76A8;
  width: fit-content;
  color: #FFFFFF;
}
.linkedin-icon {
  color: #FFFFFF;
  margin-left: 8px;
}
.container {
  max-width: 50%;
  margin-left: -1em !important;
}
.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: 1;
}
.hr-text:before {
  content: "";
  background: #E7E7E7;
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: black;
  padding: 0 0.5em;
  line-height: 1.5em;
  color: #818078;
  background-color: #fcfcfa;
}
.googleSignIn {
  border: none;
  border-radius: 2px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12);
  border: none;
  display: flex;
  color: #FFF;
  cursor: pointer;
  width: 100%;
}
.googleSignIn:hover {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);
}
.googleSignIn:active {
  background: #3367D6;
}
.googleSignIn__text {
  padding: 11px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.2px;
  text-align: left;
  white-space: nowrap;
}
.LinkedinSignIn {
  border: none;
  border-radius: 2px;
  background-color: #066093;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12);
  border: none;
  display: flex;
  padding: 1px;
  color: #FFF;
  cursor: pointer;
  width: 100%;
}
.LinkedinSignIn:hover {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);
}
.LinkedinSignIn:active {
  background: #066093;
}
.linkedin-new {
  color: #FFFFFF;
  text-align: center;
  background-color: #0077B5;
  justify-content: center;
  top: 50%;
  left: 50%;
}
.linkedin-icon-new {
  width: 40px;
  height: 38px;
  font-size: 20px;
  padding: 10px;
}
.or-text {
  position: absolute !important;
  right: -20px;
  top: 64px;
  color: #818078;
}
.h-35 {
  height: 35px;
}
.bgRequestBtn:focus {
  border: 1px solid black;
}
@media only screen and (max-width: 425px) {
  .signupmobile {
    overflow: scroll;
  }
}
.newbgcolor {
  height: 100vh;
  background-color: #E4F1F3;
  width: 100%;
}
.newbgcolor .row.mx-0 {
  height: 100%;
}
.newbgcolor .newebbtrreebgcolor {
  background-image:
    linear-gradient(
      167deg,
      #132 -14%,
      #517fa4 123%);
  position: relative;
}
.newbgcolor .newebbtrreebgcolor .sidebanner {
  background-image: url("./media/newloginsidebanner-VKIJZPU2.png");
  background-size: contain;
  background-position: left top;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  background-position: right bottom;
  position: absolute;
  right: 0;
  bottom: 0;
}
.newbgcolor .newebbtrreebgcolor .sidebanner .textContainer {
  margin-top: 80px;
  color: #ffffff;
  text-align: center;
}
.newbgcolor .newebbtrreebgcolor .sidebanner .textContainer .talentD {
  font-size: 35px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #fff;
  margin-bottom: 15px;
}
.newbgcolor .newebbtrreebgcolor .sidebanner .textContainer .beta {
  font-size: 18px;
  font-weight: 300 !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.28;
  letter-spacing: normal;
  color: #fff;
  margin-bottom: 15px;
}
.newbgcolor .newebbtrreebgcolor .sidebanner .textContainer .sourceenrich {
  font-size: 20px;
  font-weight: 500;
  color: #BDC8C7;
  display: flex;
  align-items: center;
  justify-content: center;
}
.newbgcolor .newebbtrreebgcolor .sidebanner .textContainer .sourceenrich i.fas {
  font-size: 4px;
  margin-left: 10px;
  margin-right: 10px;
}
.formbox {
  padding: 70px 15px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.formbox .wccard {
  padding: 40px;
  width: 100%;
  border-radius: 10px;
  width: 465px;
}
.formbox .wccard .wc-form-control {
  border-radius: 3px;
  border: 1px solid #d6dde6;
}
.card-light {
  background-color: #F1F8F9;
  border-radius: 3px;
  color: #484b59;
  font-size: 14px;
  width: 465px;
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-light .fa-question-circle {
  font-size: 32px;
  color: #89CFDA;
}
.wc-ghostBtn {
  border: 1px solid #d5dee6;
  background-color: #F1F8F9;
  color: #484b59;
  transition: 0.5s;
  outline: none;
  padding: 6px 15px;
  border-radius: 3px;
}
::ng-deep ngb-modal-window.new-exp-modal .modal-dialog {
  width: 1126px;
  max-width: 1126px;
}
.mb-120 {
  margin-bottom: 100px;
}
.bg-white-h100 {
  background: white;
  height: 100vh;
}
/*# sourceMappingURL=resetpassword.component-LYLOU3ND.css.map */
